import { BaseService } from "../base-service";
import { API_BASE_URL } from "../../config";
import type { LcrOrder } from "./lcr-order.types";

const LCR_ORDERS_PATH = "/v1/orders/lcr";
const HTTP_NOT_FOUND = 404;

export class LcrOrdersService extends BaseService {
  constructor() {
    super(API_BASE_URL);
  }

  public getMyLcrOrders(): Promise<LcrOrder[]> {
    return this.getJson<LcrOrder[]>(LCR_ORDERS_PATH);
  }

  /** Resolves to null when the employee has no LCR order for the serial number. */
  public async getLcrOrder(serialNumber: string): Promise<LcrOrder | null> {
    const response = await this.fetch(`${LCR_ORDERS_PATH}/${encodeURIComponent(serialNumber)}`);
    if (response.status === HTTP_NOT_FOUND) {
      return null;
    }
    return this.parse<LcrOrder>(response);
  }

  private async getJson<T>(path: string): Promise<T> {
    return this.parse<T>(await this.fetch(path));
  }

  private async parse<T>(response: Response): Promise<T> {
    if (!response.ok) {
      throw new Error(`LCR orders API error: ${response.status}`);
    }
    return await response.json();
  }
}
